import App from './components/app'

export default App